import { getDomain } from './getParams';
import {
  configExist,
  MmToPx,
} from './';
import { saveTextProperties } from './../../redux/actions/entities/texts';

export const DEFAULT_FONT = 'Montserrat';
export const DEFAULT_FONT_SIZE = 100;
export const DEFAULT_TEXT_COLOR = '#000';

export const TEXT_PROPERTIES = {
  text: '',
  font: DEFAULT_FONT,
  color: '#000',
  shadow: false,
  stroke: false,
  strokeColor: '',
  isActive: true,
  isOverflow: false,
  isSpineText: false,
  isMoveable: true,
  isEditable: true,
  images: {
    thumbnail: {
      image: '',
      relativeURl: '',
      width: 0,
      height: 0,
    },
    full: {
      image: '',
      relativeURl: '',
      width: 0,
      height: 0,
    },

  },
};

export async function postTextData(data, dispatch) {
  const referer = getDomain();
  const imageUrl = configExist('labelsURL', referer, 'labelsURL is missing or not working from config');

  await fetch(imageUrl, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: new Headers({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    }),
  })
    .then(res => res.json())
    .catch(error => console.error('Error:', error))
    .then(async (response) => {
      if (response === undefined || response.error) {
        throw new Error('Service not running');
      }
      const {
        thumbnail,
        imageSize,
      } = response.status;

      const { absolute } = thumbnail;
      const thumbnailImage = absolute;
      const properties = {
        text: data.text,
        images: {
          thumbnail: {
            image: thumbnailImage,
            relativeURl: thumbnail.relative,
            width: imageSize.thumbnail.width,
            height: imageSize.thumbnail.height,
          },
          full: {
            image: '',
            relativeURl: '',
            width: 0,
            height: 0,
          },

        },
      };

      await dispatch(saveTextProperties(data.id, properties));
    });
}

export function getTextWrapper(photoCover, marginSizes, EditorLimit, BeforeMarginLimit, pageRatio, coverType) {
  const wrapperLimits = [];

  const TextWraper = {
    width: (EditorLimit.width - (marginSizes.left + marginSizes.right)) - BeforeMarginLimit,
    height: ((EditorLimit.height - (marginSizes.top + marginSizes.bottom)) - BeforeMarginLimit),
  };
  wrapperLimits.push(TextWraper);


  return wrapperLimits;
}



// WEBPACK FOOTER //
// ./src/redux/helpers/texts.js